import React, { useEffect, useState } from 'react';
import WaiverModal from '../WaiverModal';

interface Link {
  name: string;
  url: string;
}

interface WaiverLinksProps {
  links: Link[];
  label: string;
  addButtonLabel: string;
  onChange: (updatedLinks: { value: Link[] }) => void;
}

const WaiverLinks: React.FC<WaiverLinksProps> = ({ links, label, addButtonLabel, onChange }) => {
  const [linkList, setLinkList] = useState<Link[]>([]);
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    setLinkList(links || []);
  }, [links]);

  const addLink = (newLink: Link) => {
    const cleanedLink = cleanLink(newLink);
    const updatedLinks: any = linkList ? [...linkList, cleanedLink] : [cleanedLink];
    setLinkList(updatedLinks || []);
    onChange(updatedLinks || []);
  };

  const cleanLink = (link: Link): Link => {
    if (!/^http/.test(link.url.toLowerCase())) {
      const url = 'http://' + link.url;
      return { ...link, url };
    }
    return link;
  };

  const removeLink = (linkToRemove: Link) => {
    const updatedLinks: any = linkList.filter(link => link.name !== linkToRemove.name);
    setLinkList(updatedLinks || []);
    onChange(updatedLinks || []);
  };

  return (
    <>
      <div className="form-group mini-section">
        <label>{label}:</label>
        <div className="waiver-item-list section-content">
          {(linkList || []).map((link, index) => (
            <div key={index} className="form-control section-item waiver-item">
              <a target="_blank" href={link.url}>{link.name}</a>
              <a type="button" onClick={() => removeLink(link)} className="remove-item">X</a>
            </div>
          ))}
          <button className="btn btn-default waiver-button action-button" type="button" onClick={() => setOpen(true)}>
            {addButtonLabel}
          </button>
        </div>
      </div>
      <WaiverModal title={''} onCancel={() => setOpen(false)} isModalOpen={open} fields={[
        { label: 'Name', name: 'name', value: '', required: true },
        { label: 'URL', name: 'url', value: '', required: true },
      ]} size={'lg'} submit={(result: any) => {
        addLink(result);
        setOpen(false);
      }} />
    </>
  );
};

export default WaiverLinks;